import React, { Component } from 'react';

class Page extends Component {
  render() {
    return (
      <span className="padd5 dib">
        ...
      </span>
    )
  }
}

export default Page;
